

var _logger = require('xo-beaver/dist/logger');

var _checkout = require('xo-models/src/checkout');

var DECLINE_TYPE = {
    PRE_AUTH: 'PREAUTH'
};

/**
 * $SharedUtil is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SharedUtil', function () {

    /**
     * checks at least one FI in the plan has cpa information
     * might not be required just having for now
     */
    var isAuthRequiredInAnyFI = function isAuthRequiredInAnyFI(checkoutSession) {
        var isAuthRequired = false;
        var plans = checkoutSession && checkoutSession.getPlanList();

        // Check if any existing plans has pre auth data.
        if (plans && plans.length) {
            isAuthRequired = plans.some(function (plan) {
                /**
                 * In the PPC CPA initiative, due to constraints in the backend, Risk layer sends PPC preAuthorization data to all member checkout flows, including hermes.
                 * However, hermes is not a part of the PPC PCA. Thus, we are disabling CPA disclaimer if user only has a PPC eligible for CPA
                 */
                var isPPCReuse = plan && plan.primaryFs && plan.primaryFs.name === 'BILL_ME_LATER';
                return plan.primaryFs && plan.primaryFs.pre_authorization_instruction && !isPPCReuse;
            });
        }

        _logger.$logger.info('is_auth_required_fi', {
            isAuthRequired: isAuthRequired
        });

        return isAuthRequired;
    };

    var isSelectedPlanRequiresAuth = function isSelectedPlanRequiresAuth(plan) {
        /**
         * In the PPC CPA initiative, due to constraints in the backend, Risk layer sends PPC preAuthorization data to all member checkout flows, including hermes.
         * However, hermes is not a part of the PPC PCA. Thus, we are preventing preAuthorization call from happening if user checks out with PPC.
         */
        var isPPCReuse = plan && plan.primaryFs && plan.primaryFs.name === 'BILL_ME_LATER';
        var isPlanRequireAuth = plan && plan.primaryFs && plan.primaryFs.pre_authorization_instruction && plan.primaryFs && !isPPCReuse;

        _logger.$logger.info('is_plan_require_auth', {
            isPlanRequireAuth: isPlanRequireAuth
        });

        return isPlanRequireAuth;
    };

    /*
     * check the declined instrument is for reason auth decline
     */
    var isAuthDeclinedInstrument = function isAuthDeclinedInstrument(checkoutSession) {
        var isDeclinedInstrument = false;

        var declinedInstruments = checkoutSession.declinedInstruments || [];

        // if yes, then we make elmo call, otherwise not.
        if (declinedInstruments && declinedInstruments.length) {
            isDeclinedInstrument = declinedInstruments.some(function (instrument) {
                return instrument.decline_type === DECLINE_TYPE.PRE_AUTH;
            });
        }

        _logger.$logger.info('is_auth_declined_instrument', {
            isDeclinedInstrument: isDeclinedInstrument
        });

        return isDeclinedInstrument;
    };

    var isBoolean = function isBoolean(value) {
        return Object.prototype.toString.call(value) === '[object Boolean]';
    };

    /*
        Check if the flow is supscription v1 or subscription WPS and log results
     */
    var getSubscriptionDetails = function getSubscriptionDetails(token) {
        if (!token) {
            return {};
        }
        var isSubscriptionV1 = _checkout.$CheckoutCartModel.instance(token) && _checkout.$CheckoutCartModel.instance(token).isSubscriptionsV1();
        var isWpsSubscription = _checkout.$CheckoutAppDataModel.instance(token) && _checkout.$CheckoutAppDataModel.instance(token).is_wps_subscription_flow();

        var subscriptionType = void 0,
            integrationType = void 0;
        // Check subscription type
        if (isSubscriptionV1) {
            subscriptionType = 'subscriptions_v1';
            // Check if SDK integration type
            integrationType = window && window.xprops ? 'SDK' : 'API';
        }
        if (isWpsSubscription) {
            subscriptionType = 'subscriptions_wps';
        }
        return {
            subscriptionType: subscriptionType,
            integrationType: integrationType
        };
    };

    var logSubscriptionDetails = function logSubscriptionDetails(token, pageName) {
        var subscriptionDetails = getSubscriptionDetails(token);
        if (!subscriptionDetails) {
            return;
        }

        var _ref = subscriptionDetails || {},
            subscriptionType = _ref.subscriptionType,
            integrationType = _ref.integrationType;
        // Event key and logging susbcription type


        if (subscriptionType) {
            var logKey = 'hermes_' + pageName + '_' + subscriptionType + '_integration=' + integrationType + '_rendered';
            _logger.$logger.info(logKey, subscriptionDetails);
        }
    };

    var isPPCashToBalanceEnabled = function isPPCashToBalanceEnabled($locale) {
        return $locale.country === 'US';
    };

    var logSubscriptionEvent = function logSubscriptionEvent(token) {
        var subscriptionDetails = getSubscriptionDetails(token);
        return function () {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (subscriptionDetails.subscriptionType) {
                var prefixStateName = payload.from ? 'subscription_' + payload.from : payload.from;
                if (prefixStateName) {
                    payload.from = prefixStateName;
                }
                _logger.$logger.info('checkout_fpti', payload);
            }
        };
    };

    var getFiDetails = function getFiDetails(fiArray) {
        if (!fiArray || !Array.isArray(fiArray)) {
            return {};
        }
        var fi_cnt = fiArray.length || 0;

        var _ref2 = fiArray[0] || {},
            _ref2$is_preferred = _ref2.is_preferred,
            is_preferred = _ref2$is_preferred === undefined ? false : _ref2$is_preferred,
            _ref2$instrument_id = _ref2.instrument_id,
            chosen_fi_id = _ref2$instrument_id === undefined ? 'none' : _ref2$instrument_id,
            _ref2$type = _ref2.type,
            chosen_fi_type = _ref2$type === undefined ? 'none' : _ref2$type;

        var _ref3 = fiArray.find(function (fi) {
            return fi.is_preferred;
        }) || {},
            _ref3$instrument_id = _ref3.instrument_id,
            preferred_fi_id = _ref3$instrument_id === undefined ? 'none' : _ref3$instrument_id,
            _ref3$type = _ref3.type,
            preferred_fi_type = _ref3$type === undefined ? 'none' : _ref3$type;

        return {
            // Using approx keys here as we have to send FPTI data acc to this dictionary: https://github.paypal.com/Checkout/xo-hermes-beaver/blob/master/lib/dictionaries.js#L6
            funding_instrument_count: fi_cnt,
            chosen_funding_option: chosen_fi_id,
            card_type: chosen_fi_type,
            default_funding_option: preferred_fi_id,
            preferred_fi_type: preferred_fi_type,
            is_preferred: is_preferred
        };
    };

    return {
        isAuthRequiredInAnyFI: isAuthRequiredInAnyFI,
        isSelectedPlanRequiresAuth: isSelectedPlanRequiresAuth,
        isAuthDeclinedInstrument: isAuthDeclinedInstrument,
        getSubscriptionDetails: getSubscriptionDetails,
        logSubscriptionDetails: logSubscriptionDetails,
        isBoolean: isBoolean,
        isPPCashToBalanceEnabled: isPPCashToBalanceEnabled,
        logSubscriptionEvent: logSubscriptionEvent,
        getFiDetails: getFiDetails
    };
});

_logger.$logger;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;


//////////////////
// WEBPACK FOOTER
// ./pages/services/shared-util/index.js
// module id = ./pages/services/shared-util/index.js
// module chunks = 0